module.exports = __webpack_public_path__ + "static/media/1.164bfa75.svg";